// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as EditOrderForm from "./EditOrderForm.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Accordion$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as EditOrderDataMachine from "../../../app/repo/EditOrderDataMachine.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as EditOrderFareDetailsSection from "../fare-details/EditOrderFareDetailsSection.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";
import * as ManualUpdateOrderStatusReasonsVm from "../../view-model/ManualUpdateOrderStatusReasonsVm.bs.js";

function getPricingAccordian(crn) {
  return AccordionTypes$Catalyst.make_props({
              TAG: /* Text */0,
              _0: "Fare Details"
            }, undefined, undefined, React.createElement(EditOrderFareDetailsSection.make, {
                  crn: crn
                }), undefined);
}

function EditOrderCmp(Props) {
  var crn = Props.crn;
  var order = Props.order;
  var order_fare = Props.order_fare;
  var toggleEditOrderSidebar = Props.toggleEditOrderSidebar;
  var changeDiscardModalState = Props.changeDiscardModalState;
  var openSnackbar = Props.openSnackbar;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return /* Init */0;
      });
  var setManualOrderUpdateReason = match$1[1];
  var manualOrderUpdateReason = match$1[0];
  React.useEffect((function () {
          EditOrderDataMachine.fetchManualEditOrderReasons((function (data) {
                  return Curry._1(setManualOrderUpdateReason, (function (param) {
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                }), (function (error) {
                  return Curry._1(setManualOrderUpdateReason, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: error
                                      };
                              }));
                }), country);
          
        }), []);
  var tmp;
  if (typeof manualOrderUpdateReason === "number") {
    tmp = null;
  } else {
    switch (manualOrderUpdateReason.TAG | 0) {
      case /* Loading */0 :
          tmp = React.createElement(LoadingViewComponent$Catalyst.make, {});
          break;
      case /* Live */1 :
          tmp = React.createElement(EditOrderForm.make, {
                toggleEditOrderSidebar: toggleEditOrderSidebar,
                changeDiscardModalState: changeDiscardModalState,
                order: order,
                order_fare: order_fare,
                manualOrderUpdateReason: ManualUpdateOrderStatusReasonsVm.execute(manualOrderUpdateReason._0),
                openSnackbar: openSnackbar
              });
          break;
      case /* Error */2 :
          tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: manualOrderUpdateReason._0
              });
          break;
      
    }
  }
  var tmp$1;
  var exit = 0;
  switch (order.TAG | 0) {
    case /* Open */0 :
    case /* Accepted */1 :
    case /* Live */2 :
        exit = 1;
        break;
    default:
      tmp$1 = null;
  }
  if (exit === 1) {
    tmp$1 = React.createElement(Accordion$Catalyst.make, {
          panels: {
            hd: getPricingAccordian(crn),
            tl: /* [] */0
          }
        });
  }
  return React.createElement("div", {
              className: "c-edit-order"
            }, React.createElement("div", {
                  className: "c-edit-order-form-container"
                }, tmp), React.createElement("div", {
                  className: "c-edit-order-fare-detail"
                }, tmp$1));
}

var make = EditOrderCmp;

export {
  getPricingAccordian ,
  make ,
  
}
/* react Not a pure module */
